import { ref, computed } from 'vue';
import { resourcesService } from '@/api/resources.service';

export type SearchType = 'alphabetisch' | 'liste' | 'default';

/**
 * Verwaltet UI-spezifische Logik für die Product Overview
 * Zuständig für Anzeigemodi, Labels und Dictionary-Daten
 */
export function useProductOverviewUI() {
    const dictionary = ref<Record<string, string>>({});
    const searchType = ref<SearchType>('alphabetisch');

    /**
     * Lädt die Übersetzungsdaten für die Benutzeroberfläche
     */
    const loadDictionary = async () => {
        try {
            dictionary.value = await resourcesService.dictionaryArea('SUCHE');
        } catch (error) {
            console.error('Fehler beim Laden des Wörterbuchs:', error);
        }
    };

    /**
     * Labels mit Fallback-Werten für die UI-Elemente
     */
    const labelMore = computed(() =>
        dictionary.value['SUCHE_Mehr_anzeigen'] ?? 'mehr anzeigen'
    );

    const labelAlphabetisch = computed(() =>
        dictionary.value['SUCHE_Alphabetisch'] ?? 'Alphabetisch'
    );

    const labelListe = computed(() =>
        dictionary.value['SUCHE_Liste'] ?? 'Liste'
    );

    const labelKeyword = computed(() =>
        dictionary.value['SUCHE_Keyword'] ?? 'Stichwort'
    );

    const labelSuche = computed(() =>
        dictionary.value['SUCHE_Suchen'] ?? 'Suchen'
    );

    return {
        searchType,
        dictionary,
        labelMore,
        labelAlphabetisch,
        labelListe,
        labelKeyword,
        labelSuche,
        loadDictionary
    };
}